export default __webpack_public_path__ + "static/media/1.46c905d2.svg";